import React from 'react';
import { TicketAddon } from 'types/TicketsState';
import { useTranslation } from 'react-i18next';
import { CircleCheck } from 'lucide-react';

interface BundledAddonsSectionProps {
  addons: TicketAddon[];
}

const BundledAddonsSection: React.FC<BundledAddonsSectionProps> = ({
  addons,
}) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-wrap gap-2 sm:pl-[12px] pb-[12px] sm:pr-[12px]">
      {addons.map(item => (
        <div
          className="flex items-center gap-1 w-fit bg-neutral-40 rounded-sm px-[6px] py-[4px]"
          key={item.id}
        >
          <div className="flex gap-2 items-center">
            <CircleCheck size={16} />
            <span className="p4-semibold">{item.name}</span>
          </div>
          <span className="text-neutral-600 p4-regular">
            {t('ticketSale.included')}
          </span>
        </div>
      ))}
    </div>
  );
};

export default BundledAddonsSection;
